import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { QuarterCloseAdjustmentsService } from '@shared/services/quarter-close-adjustments.service';
import { OrganizationQuery } from '@shared/store/organization/organization.query';
import { Utils } from '@shared/utils/utils';

import {
  ChecklistComponentData,
  ChecklistComponentDataGatherEstimates,
  QuarterCloseChecklistVendorEstimateSummary,
} from '../../models/quarter-close-checklist.model';
import { ChecklistRowInfoComponent } from '../checklist-row-info/checklist-row-info.component';

@Component({
  imports: [IconComponent, TooltipDirective],
  styleUrls: ['../../quarter-close-checklist.component.scss'],
  templateUrl: './checklist-section-gather-estimates.component.html',
})
export class ChecklistSectionGatherEstimatesComponent implements ChecklistComponentData {
  private quarterCloseAdjustmentsService = inject(QuarterCloseAdjustmentsService);
  private router = inject(Router);
  private vendorsQuery = inject(OrganizationQuery);

  available = true;
  data: ChecklistComponentDataGatherEstimates = {
    disabledLock: false,
    vendorEstimateSummaries: [],
    vendorEstimateUploadClick: () => {},
  };
  id = 'GatherEstimates';
  parent!: ChecklistRowInfoComponent;
  zeroHyphen = Utils.zeroHyphen;

  async navigateToVendor(vendorId: string): Promise<void> {
    const routing = await this.router.navigate(['/period-close/expense-detail']);

    if (routing) {
      this.quarterCloseAdjustmentsService.formControlSelectedVendorSource.next([vendorId]);
    }
  }

  get vendorEstimateSummaries(): QuarterCloseChecklistVendorEstimateSummary[] {
    return this.data.vendorEstimateSummaries.filter((vendor) => {
      return this.vendorsQuery
        .allReceivesEstimateVendors()
        .find((receivesEstimateVendor) => vendor.id === receivesEstimateVendor.id);
    });
  }
}
